(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cordial-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cordial-slideshow')) {
    customElements.define('cordial-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2 || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.order = this.shuffle(this.slides.map((_, index) => index));
        this.position = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.querySelector('.cordial-campaign__controls').hidden = false;
        this.querySelector('[data-toggle]').addEventListener('click', () => { this.paused = !this.paused; this.resume(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.resume(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.resume(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.resume(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.resume(); } }, options);
        document.addEventListener('visibilitychange', () => this.resume(), options);
        this.slides.forEach(slide => {
          const video = slide.querySelector('video');
          if (video) {
            video.muted = true;
            video.addEventListener('ended', () => { if (slide === this.active && !this.stopped()) this.step(1); }, options);
            video.addEventListener('error', () => { if (slide === this.active) this.timer = setTimeout(() => this.step(1), 1000); }, options);
          }
        });
        this.show();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
        this.slides?.forEach(slide => slide.querySelector('video')?.pause());
      }
      shuffle(values) {
        for (let i = values.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [values[i], values[j]] = [values[j], values[i]];
        }
        return values;
      }
      stopped() { return this.paused || this.hovered || this.focused || document.hidden; }
      step(direction) {
        const previous = this.order[this.position];
        this.position += direction;
        if (this.position >= this.order.length) {
          this.order = this.shuffle([...this.order]);
          if (this.order[0] === previous) [this.order[0], this.order[1]] = [this.order[1], this.order[0]];
          this.position = 0;
        }
        if (this.position < 0) this.position = this.order.length - 1;
        this.show();
      }
      show() {
        clearTimeout(this.timer);
        this.slides.forEach((slide, index) => {
          slide.hidden = index !== this.order[this.position];
          const video = slide.querySelector('video');
          if (video) { video.pause(); if (!slide.hidden) video.currentTime = 0; }
        });
        this.active = this.slides[this.order[this.position]];
        const image = this.active.querySelector('img');
        if (image) image.loading = 'eager';
        const nextImage = this.slides[this.order[(this.position + 1) % this.order.length]].querySelector('img');
        if (nextImage) nextImage.loading = 'eager';
        this.querySelector('[data-counter]').textContent = `${this.position + 1} / ${this.slides.length}`;
        this.resume();
      }
      resume() {
        clearTimeout(this.timer);
        this.querySelector('[data-toggle]').textContent = this.paused ? this.dataset.play : this.dataset.pause;
        const video = this.active?.querySelector('video');
        if (this.stopped()) { video?.pause(); return; }
        if (video) {
          video.play().catch(() => { if (!this.stopped()) this.timer = setTimeout(() => this.step(1), Number(this.dataset.interval)); });
        } else this.timer = setTimeout(() => this.step(1), Number(this.dataset.interval));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
